import React from "react";

import Cotizacion from "../../components/CotizacionAccidentePersonal/CotizacionAPersonal2";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchObtenerCoberturasAP } from "../../redux/actions/aRamoAccidentesPersonales";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";

class ContainerCotizacionAPersonal2 extends React.Component {

  async componentDidMount() {
    await this.props.listarCoberturas({'empresa':'AIGMETROPOLITANA','cotizador':'travelGroup'});
    console.log(this.props.datosCoberturasAP)
  }

  render() {
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          <LoadingScreen
              loading={this.props.datosCoberturasAP.listarCoberturasAPIsLoading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Cargando datos..."
            >
            <Cotizacion datosCoberturasAP={this.props.datosCoberturasAP.listarCoberuras}/>
            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  datosCoberturasAP: state.datosCoberturasAP,
  datosCarritoAPTravelGroup : state.datosCarritoAPTravelGroup

});

const mapDispatchToProps = dispatch => {
  return {

    listarCoberturas: datos => dispatch(fetchObtenerCoberturasAP(datos)),

  };
};


export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionAPersonal2)
);
